import { render, staticRenderFns } from "./MemoHistoryList.vue?vue&type=template&id=730c22de&"
import script from "./MemoHistoryList.vue?vue&type=script&lang=js&"
export * from "./MemoHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports